import { render, staticRenderFns } from "./MentorStats.vue?vue&type=template&id=6441b501&scoped=true&"
import script from "./MentorStats.vue?vue&type=script&lang=js&"
export * from "./MentorStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6441b501",
  null
  
)

export default component.exports